import { createAction, props } from '@ngrx/store';

export const loadLogos = createAction('[LOGOS] Load');

export const loadedLogos = createAction('[LOGOS] Loaded', props<{ items: any }>());

export const errorLogos = createAction('[LOGOS] Error', props<{ error: any }>());